import { render, staticRenderFns } from "./ProductCjkLogo.vue?vue&type=template&id=777f2a14&scoped=true&"
import script from "./ProductCjkLogo.vue?vue&type=script&lang=ts&"
export * from "./ProductCjkLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f2a14",
  null
  
)

export default component.exports